const initialState = {
  user: null,
  teams: [],
  selectedTeam: null,
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SELECTED_TEAM':
      return {
        ...state,
        selectedTeam: action.payload,
      };
    default:
      return state;
  }
};

export const permissionsReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_PERMISSIONS':
      return [...action.payload];
    default:
      return state;
  }
};

export const featuresReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_FEATURES':
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
